import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { INotification } from '../components/features/Notifications/INotification'

type NotificationState = {
  notifications: INotification[]
  lastSeenAt: number
  setNotifications: (items: INotification[]) => void
  markAllRead: () => void
  reset: () => void
}

const toMs = (iso: number) => new Date(iso).getTime() || 0

export const useNotificationStore = create<NotificationState>()(
  persist(
    (set, get) => ({
      notifications: [],
      lastSeenAt: 0,

      setNotifications: (items) => {
        set({ notifications: items })
      },

      markAllRead: () => {
        const latest = Math.max(0, ...get().notifications.map(n => toMs(n.time)))
        set({ lastSeenAt: latest })
      },

      reset: () => set({ notifications: [], lastSeenAt: 0 }),
    }),
    {
      name: 'notifications',
      partialize: (s) => ({ lastSeenAt: s.lastSeenAt }),
    }
  )
)
